import React, { useEffect, useState } from "react";
import DesignStudio from "../components/ArtPage/DesignStudio";

const DESKTOP_QUERY = "(min-width: 960px)";

export default function DesignStudioPage() {
  const [isDesktop, setIsDesktop] = useState(() => {
    if (typeof window === "undefined") {
      return true;
    }
    return window.matchMedia(DESKTOP_QUERY).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined") {
      return undefined;
    }
    const mediaQuery = window.matchMedia(DESKTOP_QUERY);
    const handleChange = (event) => setIsDesktop(event.matches);

    handleChange(mediaQuery);
    if (typeof mediaQuery.addEventListener === "function") {
      mediaQuery.addEventListener("change", handleChange);
      return () => mediaQuery.removeEventListener("change", handleChange);
    }
    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  if (isDesktop) {
    return <DesignStudio />;
  }

  return (
    <div className="ds-page ds-page--guard">
      <div className="ds-container ds-guard">
        <h1 className="ds-guard__title">Desktop Required</h1>
        <p className="ds-guard__message">
          The Design Studio is available on desktop browsers only. Open this page on a
          laptop or desktop computer to launch the workspace.
        </p>
      </div>
    </div>
  );
}
